import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedCustomerVehicleImagesQueryParamsType,
  GetDamagedCustomerVehicleImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerVehicleImages/getDamagedCustomerVehicleImagesQuery.type';

export const getDamagedCustomerVehicleImagesFunction = (
  params: GetDamagedCustomerVehicleImagesQueryParamsType,
): Promise<GetDamagedCustomerVehicleImagesQueryResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/images/customer/vehicle/`,
    { params: { damaged_id: params.damaged_id } },
  );
};
